import { MatchListStoreModel } from '../../../match-list/utils/match-list-models'
import { AppAction } from '@om-fe/store';
import { TimeRangeType } from '../../utils/top-bets.constants';

export const TOP_BETS_MATCH_LIST_PATH: string = 'next-matches-aggregator-groups-overview-top-bets/:disciplineId/:timeRange';
export const TOP_BETS_MATCH_LIST_BY_HOURS_PATH: string = 'next-matches-aggregator-groups-overview-top-bets-by-hours/:disciplineId/:timeRange';
export const TOP_BETS_MATCH_LIST_BY_DATES_PATH: string = 'next-matches-aggregator-groups-overview-top-bets-by-dates/:disciplineId/:timeRange';
export const TOP_BETS_MATCH_LIST_BY_DATES_PATH_LOGGED_IN: string = 'next-matches-aggregator-groups-overview-top-bets-by-dates/logged-in-users/:disciplineId/:timeRange';
export const TOP_BETS_MATCH_LIST_ALL_PATH: string = 'next-matches-aggregator-groups-overview-lm-sorted/:disciplineId/:timeRange';
export const TOP_BETS_MATCH_LIST_ALL_BY_HOURS_PATH: string = 'next-matches-aggregator-groups-overview-lm-sorted-by-hours/:disciplineId/:timeRange';
export const TOP_BETS_MATCH_LIST_ALL_BY_DATES_PATH: string = 'next-matches-aggregator-groups-overview-lm-sorted-by-dates/:disciplineId/:timeRange';
export const TOP_BETS_MATCH_LIST_ALL_BY_DATES_PATH_LOGGED_IN: string = 'next-matches-aggregator-groups-overview-lm-sorted-by-dates/logged-in-users/:disciplineId/:timeRange';
export const TOP_BETS_MATCH_LIST_LOCATION_PATH: string = 'next-matches-aggregator-groups-overview-top-bets/:disciplineId/:locationId/:timeRange';
export const TOP_BETS_MATCH_LIST_LOCATION_BY_HOURS_PATH: string = 'next-matches-aggregator-groups-overview-top-bets-by-hours/:disciplineId/:locationId/:timeRange';
export const TOP_BETS_MATCH_LIST_LOCATION_BY_DATES_PATH: string = 'next-matches-aggregator-groups-overview-top-bets-by-dates/:disciplineId/:locationId/:timeRange';
export const TOP_BETS_MATCH_LIST_LOCATION_BY_DATES_PATH_LOGGED_IN: string = 'next-matches-aggregator-groups-overview-top-bets-by-dates/logged-in-users/:disciplineId/:locationId/:timeRange';
export const TOP_BETS_MATCH_LIST_LOCATION_ALL_PATH: string = 'next-matches-aggregator-groups-overview-lm-sorted/:disciplineId/:locationId/:timeRange';
export const TOP_BETS_MATCH_LIST_LOCATION_ALL_BY_HOURS_PATH: string = 'next-matches-aggregator-groups-overview-lm-sorted-by-hours/:disciplineId/:locationId/:timeRange';
export const TOP_BETS_MATCH_LIST_LOCATION_ALL_BY_DATES_PATH: string = 'next-matches-aggregator-groups-overview-lm-sorted-by-dates/:disciplineId/:locationId/:timeRange';
export const TOP_BETS_MATCH_LIST_LOCATION_ALL_BY_DATES_PATH_LOGGED_IN: string = 'next-matches-aggregator-groups-overview-lm-sorted-by-dates/logged-in-users/:disciplineId/:locationId/:timeRange';
export const TOP_BETS_MATCH_LIST_CATEGORY_PATH: string = 'next-matches-aggregator-groups-overview-by-event-category-top-bets/:disciplineId/:categoryId/:timeRange';
export const TOP_BETS_MATCH_LIST_CATEGORY_BY_HOURS_PATH: string = 'next-matches-aggregator-groups-overview-by-event-category-top-bets-by-hours/:disciplineId/:categoryId/:timeRange';
export const TOP_BETS_MATCH_LIST_CATEGORY_BY_DATES_PATH: string = 'next-matches-aggregator-groups-overview-by-event-category-top-bets-by-dates/:disciplineId/:categoryId/:timeRange';
export const TOP_BETS_MATCH_LIST_CATEGORY_BY_DATES_PATH_LOGGED_IN: string = 'next-matches-aggregator-groups-overview-by-event-category-top-bets-by-dates/logged-in-users/:disciplineId/:categoryId/:timeRange';
export const TOP_BETS_MATCH_LIST_CATEGORY_ALL_PATH: string = 'next-matches-aggregator-groups-overview-by-event-category-lm-sorted/:disciplineId/:categoryId/:timeRange';
export const TOP_BETS_MATCH_LIST_CATEGORY_ALL_BY_HOURS_PATH: string = 'next-matches-aggregator-groups-overview-by-event-category-lm-sorted-by-hours/:disciplineId/:categoryId/:timeRange';
export const TOP_BETS_MATCH_LIST_CATEGORY_ALL_BY_DATES_PATH: string = 'next-matches-aggregator-groups-overview-by-event-category-lm-sorted-by-dates/:disciplineId/:categoryId/:timeRange';
export const TOP_BETS_MATCH_LIST_CATEGORY_ALL_BY_DATES_PATH_LOGGED_IN: string = 'next-matches-aggregator-groups-overview-by-event-category-lm-sorted-by-dates/logged-in-users/:disciplineId/:categoryId/:timeRange';
export const TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_BY_HOURS_PATH: string = 'next-matches-aggregator-groups-overview-by-event-category-top-bets-by-hours/:categoryId/:timeRange';
export const TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_BY_DATES_PATH: string = 'next-matches-aggregator-groups-overview-by-event-category-top-bets-by-dates/:categoryId/:timeRange';
export const TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_BY_DATES_PATH_LOGGED_IN: string = 'next-matches-aggregator-groups-overview-by-event-category-top-bets-by-dates/logged-in-users/:categoryId/:timeRange';
export const TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_ALL_BY_HOURS_PATH: string = 'next-matches-aggregator-groups-overview-by-event-category-lm-sorted-by-hours/:categoryId/:timeRange';
export const TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_ALL_BY_DATES_PATH: string = 'next-matches-aggregator-groups-overview-by-event-category-lm-sorted-by-dates/:categoryId/:timeRange';
export const TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_ALL_BY_DATES_PATH_LOGGED_IN: string = 'next-matches-aggregator-groups-overview-by-event-category-lm-sorted-by-dates/logged-in-users/:categoryId/:timeRange';
export const TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_BY_HOURS_PATH: string = 'next-matches-aggregator-groups-overview-top-bets-by-hours/:locationId/:timeRange';
export const TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_BY_DATES_PATH: string = 'next-matches-aggregator-groups-overview-top-bets-by-dates/:locationId/:timeRange';
export const TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_BY_DATES_PATH_LOGGED_IN: string = 'next-matches-aggregator-groups-overview-top-bets-by-dates/logged-in-users/:locationId/:timeRange';
export const TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_ALL_BY_HOURS_PATH: string = 'next-matches-aggregator-groups-overview-lm-sorted-by-hours/:locationId/:timeRange';
export const TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_ALL_BY_DATES_PATH: string = 'next-matches-aggregator-groups-overview-lm-sorted-by-dates/:locationId/:timeRange';
export const TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_ALL_BY_DATES_PATH_LOGGED_IN: string = 'next-matches-aggregator-groups-overview-lm-sorted-by-dates/logged-in-users/:locationId/:timeRange';

export const slicePrefix = 'top-bets';

export interface TopBetsMatchListStoreModel extends MatchListStoreModel {
    readonly ready: boolean;
    readonly isLoadingMoreData: boolean;
    readonly isLoadingData: boolean;
    readonly disciplineId?: string;
    readonly mainMarketsLimit?: number;
    readonly limit: number;
    readonly totalRecords: number;
    readonly timeRange: string,
    readonly marketGroupsOverviewIds: string;
    readonly marketGroupsOverviewNumber?: number;
    readonly locationId?: string;
    readonly categoryId?: string;
    readonly isTopBets?: boolean;
    readonly isCategory?: boolean;
    readonly timeRangeType?: TimeRangeType;
    readonly timeRangeValue?: string;
    readonly isAuthenForTopic?: boolean;
}

export enum TopBetsMatchListActions {
    SetLoadingData = 'sports:top-bets-list:set-loading-data',
    SetFilterData = 'sports:top-bets-list:set-match-list-filter-data',
}

export interface TopBetsMatchListSetLoadingData extends AppAction<TopBetsMatchListActions.SetLoadingData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly isLoadingMoreData: boolean;
    };
}

export interface TopBetsMatchListSetFilterDataAction extends AppAction<TopBetsMatchListActions.SetFilterData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly limit: number;
        readonly disciplineId: string;
        readonly timeRange: string;
        readonly mainMarketsLimit: number | undefined;
        readonly marketGroupsOverviewIds: string;
        readonly marketGroupsOverviewNumber?: number;
        readonly isTopBets?: boolean;
        readonly locationId?: string;
        readonly categoryId?: string;
        readonly isCategory?: boolean;
        readonly timeRangeType?: TimeRangeType;
        readonly timeRangeValue?: string;
        readonly isAuthenForTopic?: boolean;
    };
}

export interface TopBetsMatchListTopic {
    readonly path: string;
    readonly params: {
        readonly disciplineId: string;
        readonly nrOfMarkets: number;
        readonly limitNumberOfEvents: number;
        readonly marketGroupsOverviewIds: string;
        readonly marketGroupsOverviewNumber?: number;
        readonly isAuthenForTopic?: boolean;
    };
}

export interface TopBetsMatchListGroupsTopic {
    readonly path: string;
    readonly params: {
        readonly disciplineId: string;
        readonly eventsNumber: number;
        readonly marketGroupsOverviewNumber: number;
    };
}

export interface TopBetsMatchListGroupsOverviewTopic {
    readonly path: string;
    readonly params: {
        readonly disciplineId?: string;
        readonly limit: number;
        readonly timeRange: string;
        readonly groupOverviewId: string;
        readonly locationId?: string;
        readonly categoryId?: string;
        readonly isAuthenForTopic?: boolean;
    };
}